import React from 'react';
import { NodeProps, useReactFlow } from 'reactflow';
import { Main, Styled } from './style';
import { SettingsBlock, settingsDataType } from '../../../../settingsBlock';
import { IoCheckmarkCircleOutline, IoWarningOutline } from 'react-icons/io5';
import { ExpandedBlock } from '../../../expanded';
import { operationType } from '../../../../../services/types';
import { TextInput } from '../../../../form/textInput';
import { updateNodeValue } from '../../../../../services/method';

type EditFieldsProps = NodeProps<operationType> & {
   setChildMinimize?: (fn: (id: string) => void) => void;
   setChildSettings?: (fn: (id: string) => void) => void;
};

export function WaitBlock({ id, data, setChildMinimize, setChildSettings }: EditFieldsProps) {
   const { setNodes } = useReactFlow();
   const [settings, setSettings] = React.useState<settingsDataType>({ isToggle: false });
   const [isExpanded, setIsExpanded] = React.useState(false);
   
   // --
   React.useEffect(() => {
      if (setChildMinimize) setChildMinimize(() => { setIsExpanded(prev => !prev) });
      if (setChildSettings) setChildSettings(() => { setSettings(prev => ({ ...prev, isToggle: !prev.isToggle })) });
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [setChildMinimize, setChildSettings]);

   // ---
   const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>, keyRef?: string) => {
      const value = e.target.value;
      if (keyRef) updateNodeValue(id, setNodes, { [keyRef]: value });
   }

   // --- 
   const isWarning = false;
   
   return (<>
      <SettingsBlock nodeId={ id } data={ settings } setData={ setSettings } />
      <Main>
         { isWarning ? <>
            <div id="warning"></div>
            <span id="warningIcon"><IoWarningOutline size={ 21 } /></span>
         </> : data.output ? <>
            <div id="ran"></div>
            <span id="ranIcon"><IoCheckmarkCircleOutline size={ 21 } /></span>
         </> : null}
         { isExpanded ? <ExpandedBlock
            data={{ id, ...data }} 
            handleClose={ () => setIsExpanded(false) } 
            isWarning={ isWarning }
            style={{ minWidth: '320px' }}
         ><Styled>
            <span>Pause the process for a specific period of time</span>
            <TextInput keyRef="timer" placeholder="time (Maximum 60 seconds)" value={ data.value?.timer } handleChange={ handleChangeInput } />
         </Styled></ExpandedBlock> : null}
      </Main>
   </>);
}